export const remove_from_str = (...signs: string[]) => (str: string) =>
  signs.reduce((acc, sign) => {
    const exp = new RegExp(sign, "g");
    acc = acc.replace(exp, "");
    console.log(acc);
    return acc;
  }, str);

export const post_fix_with_if_not_exist = (post_fix: string) => (
  str: string
) => {
  if (str.endsWith(post_fix)) {
    return str;
  } else {
    return str + post_fix;
  }
};
